import isElectron from './isElectron';
import { run } from '../helper/electron';

export const POLICY_URLS = {
  cookie: 'https://www.cratehackers.com/privacy#cookies',
  terms: 'https://www.iubenda.com/terms-and-conditions/74902040',
  privacy: 'https://www.cratehackers.com/privacy',
} as const;

export const openPolicyLink = (url: string) => {
  if (isElectron()) {
    run('openPolicyLink', url);
  } else {
    window.open(url, '_blank');
  }
};
